<!-- <carousel #innerOffersCaraousel style="z-index:1;" (click)="showPage($event)"  [borderRadius]="20" [cellsToShow]="1" [cellWidth]="552" [height]="height" *ngIf="bannerImages && bannerImages.length>0"
    [images]="bannerImages"> 
    </carousel>-->
<!-- <carousel #innerOffersCaraousel [borderRadius]="20" style="z-index:1;"  [cellsToShow]="1"
    [cellWidth]="552" [height]="height" *ngIf="bannerImages && bannerImages.length>0" >
    <div class="carousel-cell" *ngFor="let item of bannerImages; let i = index">
        <img *ngIf="canShowImage(item)" [src]="item.path" [alt]="item.alt" >
        <div *ngIf="canShowVideo(item)" class="video-wrapper">
            <iframe [src]="item.transformedPath" allow="autoplay" 
                 frameborder="0" referrerpolicy="strict-origin-when-cross-origin" class="iframevideo" allowfullscreen>
            </iframe>
            <div class="newDivOverlay" (click)="playVideo()">
            </div>
        </div>
    </div>
</carousel> -->

<!-- <div class="item" id="offerplaceholder">
        <div class="full-image">
            <a href="javascript:;">
                <img src="./assets/images/loader.gif" width="10%" height="auto" alt="" class="d-xl-block" style="margin: 0 auto;">
            </a>
        </div>
    </div> -->



    <div class="carousel-container" [style.height]="height" style="z-index:1;">
        <div class="main-slider">
          <button (click)="prevMainBanner()" class="carousel-button arrow left-arrow" [disabled]="currentIndex === 0">
            <img src="/assets/images/leftArrow.svg" alt="Next" width="28" height="28" class="arrowcustom">
          </button>
           <div class="main-banner">  
            <img class="imgBanner" *ngIf="canShowImage(currentBanner)" [src]="currentBanner.path" [alt]="currentBanner.alt">
            <ng-container *ngIf="canShowVideo(currentBanner)">
              <div class="video-wrapper" (click)="playVideo()">
                <iframe #videoFrame class="iframe" [src]="transform(currentBanner.path)" title="YouTube video player" allow="autoplay; fullscreen"
                  scrolling="no" frameborder="0" referrerpolicy="strict-origin-when-cross-origin">
                </iframe>
              </div>
            </ng-container>
          </div>
          <button (click)="nextMainBanner()" class="arrow right-arrow carousel-button" [disabled]="currentIndex === bannerImages.length - 1">
            <img src="/assets/images/rightArrow.svg"  alt="Next" width="28" height="28" class="arrowcustom">
          </button>
        </div>
    </div>